const Button = {
  baseStyle: {
    fontWeight: 600,
    borderRadius: 'md',
    transitionDuration: '200ms',
    _focusVisible: { boxShadow: 'outline' },
  },
  sizes: {
    md: { fontSize: 'sm', h: '44px', px: 6 },
    lg: { fontSize: 'md', h: '52px', px: 8 },
  },
  variants: {
    // Declarar variantes propias SUSTITUYE las de Chakra: `ghost`,
    // `outline` y `solid` dejan de existir y cualquier componente que las
    // pida se renderiza sin estilo -invisible pero presente-. Le pasó al
    // menú de acciones de las tablas, que usa `ghost`. Se redefinen aquí
    // con los tokens del proyecto en vez de dejarlas rotas.
    ghost: {
      bg: 'transparent',
      color: 'inherit',
      _hover: { bg: 'blackAlpha.100' },
      _active: { bg: 'blackAlpha.200' },
    },
    outline: {
      bg: 'transparent',
      color: 'inherit',
      border: '1px solid',
      borderColor: 'border.strong',
      _hover: { bg: 'blackAlpha.50' },
      _active: { bg: 'blackAlpha.100' },
    },
    solid: {
      bg: 'accent.default',
      color: 'text.inverse',
      _hover: { bg: 'accent.hover', _disabled: { bg: 'accent.default' } },
      _active: { bg: 'accent.active' },
    },
    primary: {
      bg: 'accent.default',
      color: 'text.inverse',
      _hover: { bg: 'accent.hover', _disabled: { bg: 'accent.default' } },
      _active: { bg: 'accent.active' },
    },
    secondary: {
      bg: 'transparent',
      color: 'accent.default',
      border: '1px solid',
      borderColor: 'border.strong',
      _hover: { bg: 'surface.muted', borderColor: 'accent.default' },
    },
    inverse: {
      bg: 'transparent',
      color: 'text.inverse',
      border: '1px solid',
      borderColor: 'whiteAlpha.700',
      _hover: { bg: 'whiteAlpha.200', borderColor: 'white' },
    },
    text: {
      bg: 'transparent',
      color: 'accent.default',
      px: 0,
      h: 'auto',
      minH: '44px',
      _hover: { textDecoration: 'underline' },
    },
    whatsapp: {
      bg: 'whatsapp.500',
      color: 'white',
      _hover: { bg: 'whatsapp.600' },
    },
  },
  defaultProps: { variant: 'primary', size: 'md' },
};

export default Button;
